















import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class IconItem2 extends Vue {
  @Prop()
  icon;
}
